import React from "react";
import { Formik } from "formik";
import { Form, Col, Row } from "react-bootstrap";

export function CourseEditForm({ 
  course,
  btnRef,
  saveCourse
}) {
  return (
    <Formik 
      enableReinitialize={true}
      initialValues={course}
      onSubmit={(values) => saveCourse(values)}
    >
      {({ handleSubmit, handleChange, values }) => (
        <Form onSubmit={(e) => {
          e.preventDefault();
          handleSubmit();
        }}>
          <Form.Group as={Row} controlId="name">
            <Form.Label column sm={2}>
              Adı<span> *</span>
            </Form.Label>
            <Col sm={10}>
              <Form.Control type="text" value={values.name} placeholder="Adı" onChange={handleChange} />
            </Col>
          </Form.Group>

          <button
            type="submit"
            style={{ display: "none" }}
            ref={btnRef}
          ></button>
        </Form>
      )}      
    </Formik>
  );
}